import {Product} from './Product';
import {OrderItem} from './OrderItem';
import {OrderItemProductPackage} from './OrderItemProductPackage';
import {Package} from './Package';
import {ProductCost} from './ProductCost';
import {TotalCost} from './TotalCost';
import {FabricCollection} from './FabricCollection';
import {Fabric} from './Fabric';
import {FabricColor} from './FabricColor';
import {OrderItemProductFabricCollection} from './OrderItemProductFabricCollection';
import {OrderItemProductOption} from './OrderItemProductOption';
import {SummaryOption} from './SummaryOption';
import {OrderItemOption} from './OrderItemOptions';

export class OrderItemProduct {
  public id: number;
  public amount = 1;
  public product: number | Product;
  public oldProduct: number;
  public productObj: Product;
  public orderItemProductPackages: OrderItemProductPackage[];
  public orderItemProductFabricCollection: OrderItemProductFabricCollection;
  public orderItemProductFabricCollections?: OrderItemProductFabricCollection[];
  public orderItemProductOptions?: OrderItemProductOption[];
  public orderItemOptions?: OrderItemOption[];
  public allowFabric: boolean;
  public random?: number;
  public cost = new ProductCost();
  public totalCost = new TotalCost();
  public totalArticleProductFabricCustomerPrice?: number = 0;
  public totalArticleProductFabricDealerPrice?: number = 0;
  public stockAmountAlert?: StockAmountAlert = new StockAmountAlert();
  public summaryOptions: SummaryOption[] = [];
  public orderItem: OrderItem;
  public perProductOptionObj: any;
  public perProductOptions?: OrderItemOption[];
  public allowFabricSide: boolean;
  public selectedPerProductOption?: OrderItemOption;
  /**
   * Carpets & Rugs — the dealer's chosen dimensions, whole centimetres.
   * Both sizing modes write here (FR-020); `amount` stays the unit count and
   * must never hold a dimension. `selectedSizeId` is view state for the preset
   * dropdown only and is not sent to the API.
   */
  public widthCm?: number;
  public lengthCm?: number;
  public selectedSizeId?: number;
  public carpetCost?: any;
  public carpetDescription?: string;
  /**
   * This element's own shape / finishing / colour, keyed by carpet role. Per element,
   * not per article: two elements under one article carry independent choices, and one
   * element with a higher `amount` carries a single set. View state — the API receives
   * the resulting `orderItemOptions` rows nested under this element instead.
   */
  public carpetOptions?: {[role: string]: number};

  /**
   * The material-only component of a carpet line's dealer price, served alongside the
   * line total (never instead of it). The product row shows this, because shape and
   * finishing render their own rows below it; the article subtotal and the order total
   * keep using totalCost, which stays the combined total.
   */
  public carpetMaterialPrice?: number;

  /** The same figure in the customer scope, for the Dealer price / Customer price toggle. */
  public carpetMaterialCustomerPrice?: number;
  /** Cached carpet option groups for this element's product — see carpetOptionGroupsFor() */
  public carpetOptionGroups?: {product: number, groups: any[]};
  /**
   * Read-only, from the API: the option ids chosen for THIS element. The order-level
   * option list only names a Product, so this is what tells two elements holding the
   * same rug apart when an order is reopened.
   */
  public orderItemOptionIds?: number[];
}


export class StockAmountAlert {
  public color?: string;
  public message?: string;
  public shouldShow?: boolean = false;
}

